/** Longueur de la piste, en mètres. */
export const TRACK_LENGTH_M = 100;

/** Nombre de couloirs (coureurs) par série. */
export const LANE_COUNT = 8;

/** Nombre de coureurs qualifiés par série (hors finale). */
export const QUALIFIERS_PER_HEAT = 4;

/** Tailles de tournoi autorisées (humains + bots). Toujours un multiple de {@link LANE_COUNT}. */
export const FIELD_SIZES = [8, 16, 32, 64, 128] as const;
export type FieldSize = (typeof FIELD_SIZES)[number];
export const DEFAULT_FIELD_SIZE: FieldSize = 8;

export const MAX_SPECTATORS_PER_ROOM = 200;

export const NICKNAME_MIN_LENGTH = 2;
export const NICKNAME_MAX_LENGTH = 16;

/** Alphabet sans caractères ambigus (0/O, 1/I/L). */
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
export const ROOM_CODE_LENGTH = 5;

/** Fréquence de la simulation serveur (Hz). */
export const SIM_HZ = 60;
/** Fréquence d'envoi des snapshots aux clients (Hz). */
export const SNAPSHOT_HZ = 30;

/** Paramètres de la physique du coureur. */
export const PHYSICS = {
  /** Gain de vitesse (m/s) à chaque pas valide (alternance gauche/droite). */
  stepImpulse: 1.17,
  /** Coefficient de frottement (1/s) : la vitesse décroît exponentiellement. */
  drag: 1.1,
  /** Vitesse maximale (m/s). */
  maxSpeed: 11,
  /** Durée pendant laquelle le coureur reste au sol après une chute (ms). */
  fallDurationMs: 1000,
  /** Deux touches pressées à moins de cet écart (ms) sont considérées simultanées. */
  simultaneousWindowMs: 50,
  /** Plafond anti-triche : nombre de pas maximum comptabilisés par seconde. */
  maxStepsPerSecond: 18,
} as const;

/** Durées des phases d'un tournoi (ms). */
export const TIMING = {
  briefingMs: 7000,
  /** Décompte avant le départ (« 3, 2, 1, partez »). */
  countdownMs: 4000,
  resultsMs: 8000,
  /** Délai entre l'arrivée de la finale et l'écran du podium. */
  finalDelayMs: 4000,
  /** Durée maximale d'une course avant que les non-arrivés soient classés DNF. */
  raceTimeoutMs: 30_000,
  /** Délai laissé aux bots après l'arrivée du dernier humain connecté. */
  humansDoneGraceMs: 3000,
  /** Pause entre deux tours entièrement simulés (aucun humain en course). */
  skippedRoundMs: 1500,
} as const;

/** Délais de gestion des connexions (ms). */
export const ROOM_TIMING = {
  /** Temps laissé à un joueur déconnecté du lobby pour revenir avant d'être retiré. */
  lobbyReconnectGraceMs: 30_000,
  /** Durée sans aucun joueur connecté avant destruction du salon. */
  emptyRoomTtlMs: 3 * 60_000,
} as const;
